module.exports = __webpack_public_path__ + "static/media/circled-statement@3x.1f8419ed.png";